import { useEffect } from 'react';
import { aiChatcheckLocale  } from '../../utils/index';

let ADA_LOADED = false;

const AdaChatLoader = () => {
  const storedUser = JSON.parse(localStorage.getItem("_customerDetails"));
  const locale = storedUser?.locale;
  const subscriberId = storedUser?.subscriberId;
  const leadId = storedUser?.leadId;
  const applicationType = storedUser?.applicationType;
  const adaHandler = window.weeksWebCloudConfig?.ADA_HANDLER;

  useEffect(() => {
    if (!locale) {
      return;
    }
    if (!aiChatcheckLocale(locale)) {
    return null;
    }

    if (ADA_LOADED) return;
    ADA_LOADED = true;

    const settings = document.createElement("script");
    settings.innerHTML = `
      window.adaSettings = {
        handle: "${adaHandler || ''}",
        cluster: "us2",
        metaFields: {
          subscriberId: "${subscriberId || ''}",
          applicationType: "${applicationType || ''}",
          leadId: "${leadId || ''}",
          locale: "${locale || ''}",
          isMember: 'true',
          referringSite: window.location.href,
          browser: navigator.userAgent,
        },
      };
    `;
    document.head.appendChild(settings);

    const adaScript = document.createElement("script");
    adaScript.src = "https://static.ada.support/embed2.js";
    adaScript.async = true;

    adaScript.onload = () => {};
    adaScript.onerror = () => console.error("Failed to load ADA");

    setTimeout(() => {
      document.head.appendChild(adaScript);
    }, 0);

  }, [locale]);

  return null;
};

export default AdaChatLoader;